const constants = {
  ROUTES: {
    DASHBOARD: 'dashboard',
    LOCATIONVIEW: 'location',
    SITEVIEW: 'site',
    ADD_STEM: 'addstem',
    SUBSCRIPTIONVIEW: 'subscription',
    SETTINGS: 'settings',
    TUTORIAL: 'tutorial',
    LOGIN: 'login',
    CHOOSE_LOCATION: 'chooselocation',
    ALERTS: 'alerts',
    SIGNUP : 'signup'
  },
  CHART_OPTIONS: {
    // TOP: 'deepSensor1',
    // MIDDLE: 'deepSensor2',
    // BOTTOM: 'deepSensor3'
    TOP: '1',
    MIDDLE: '2',
    BOTTOM: '3',
    ONBOARDSENSOR: 'onboard',
    ZOOM: 'zoom'
  },
  TREND_OPTIONS: {
    RAW: 'RAW',
    TRENDLINE: 'TRENDLINE',
    BOTH: 'BOTH'
  },
  CHART_LIMIT: {
    TOP: 'upper',
    LOWER: 'lower',
  },
  DATE_RANGE: {
    ALL: 'ALL',
    ONE_YEAR: 'ONE_YEAR',
    ONE_TO_ELEVAN_MONTHS: 'ONE_TO_ELEVAN_MONTHS',
    TWO_WEEKS: 'TWO_WEEKS',
    ONE_WEEK: 'ONE_WEEK',
    ONE_MONTH: 'ONE_MONTH',
    SIX_MONTHS: 'SIX_MONTHS',
    ONE_DAY: 'ONE_DAY',
    LAST_SIX_HOURS: 'LAST_SIX_HOURS',
    LAST_HOUR: 'LAST_HOUR',
    CUSTOM: 'CUSTOM',
    NONE:'NONE'
  },
  TWIG_EDIT_CONTROLS: {
    NUMBER_ARRAY: 'numberArray',
    STRING_ARRAY: 'stringArray',
    SELECT: 'select',
    NUMBER: 'number',
    SENSOR_TYPE: 'sensorType',
    BOOLEAN: 'boolean',
    BOOLEAN1: 'boolean1',
    TEXT: 'text'
  },
  DATE_TIMESTAMP : {
    lastHour : '23:59:59.000Z'
  },
  STRIPE_PLACEHOLDER : {
    CARD_NUMBER : 'cardNumber',
    EXPIRY: 'expiry',
    CVC: 'cvc'
  },
  STRIPE_PLANS : {
    MONTHLY : "month"
  },
  MESSAGES : {
    SUCCESS :{
      USER_PROFILE_UPDATED : "User profile updated successfully",
      USER_PASSWORD_UPDATED: "User profile updated successfully. Password changed. You will be logged out of the application shortly. Please login to continue"
    },
    ERROR : {
      GENERAL_ERROR : "Oops!!! Something went wrong. Please try again after some time"
    }
  }
};

export default constants;


// WEBPACK FOOTER //
// ./src/js/Constants.js